<template>
  <div class="tender-list-breakdown">
    <div class="tender-list-wrapper no-scroll">
      <div class="tender-list incoming-tender-list">
        <TenderBreakdownHeader
          :currency="currency"
          class="incoming-tender-list-row_breakdown"
          :style="breakdownWidthGrid"
          breakdown-header
          :opened-columns="openedColumns"
          :offers="offers"
          @toggle-column="(index) => $emit('toggle-column', index)"
        />
        <div v-for="(rowWrapper, index, priorityIndex) in breakdownRows" :key="index">
          <TenderListBreakdownRowCompany
            class="pointer"
            :style="breakdownWidthGrid"
            :is-company-open="!closedCompanies.includes(index)"
            :parent-row-index="parentRowIndex"
            :index="
              getSerialIndex({
                index: priorityIndex,
                row: rowWrapper,
                company: true,
              })
            "
            :company-name="get(rowWrapper, 'tender_offer.contractor_team.name')"
            :opened-count="openedColumns.length"
            :offers-count="Object.keys(selectedVersion).length"
            @toggle-company="toggleCompany(index)"
          />
          <div v-if="!closedCompanies.includes(index) && selectedVersion[index]" class="d-contents">
            <TenderListBreakdownRow
              v-for="(row, rowIndex) in rowWrapper.breakdown_rows"
              :key="row.id"
              :currency="currency"
              :style="breakdownWidthGrid"
              :index-priority="selectedVersion[index].versionPriorityIndex"
              :cell-groups-after="cellGroupsAfter(index)"
              :opened-columns-after="openedColumnsAfter(index)"
              :opened-columns-before="openedColumnsBefore(index)"
              :is-opened="isOpened(index)"
              :row-index="getSerialIndex({ index: rowIndex, row: rowWrapper })"
              :row="row"
              :parent-row-index="parentRowIndex"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import get from 'lodash.get';
  import TenderBreakdownHeader from '@/containers/tender/tender-list/TenderBreakdownHeader';
  import TenderListBreakdownRow from '@/containers/tender/tender-list/TenderListBreakdownRow';
  import TenderListBreakdownRowCompany from '@/containers/tender/tender-list/TenderListBreakdownRowCompany';
  import {
    GENERAL_ESTIMATE_COLUMN_WIDTH,
    WIDE_COLUMN_DELTA,
    DEFAULT_COLUMN_WIDTH,
  } from '@/containers/tender/tender-list/constants';

  export default {
    name: 'TenderListBreakdown',
    components: {
      TenderListBreakdownRowCompany,
      TenderListBreakdownRow,
      TenderBreakdownHeader,
    },
    props: {
      currency: {
        type: String,
        required: true,
      },
      openedColumns: {
        type: Array,
        required: true,
      },
      offers: {
        type: Array,
        required: true,
      },
      parentRow: {
        type: Object,
        required: true,
      },
      breakdownRows: {
        type: Object,
        required: false,
      },
      selectedVersion: {
        type: Object,
        required: true,
      },
      parentRowIndex: {
        type: Number,
        required: false,
      },
    },
    data() {
      return {
        closedCompanies: [],
        breakdownRowsCounter: [],
      };
    },
    computed: {
      breakdownWidthGrid() {
        const countOfDynamicCells =
          this.offers.length * DEFAULT_COLUMN_WIDTH + this.openedColumns.length * WIDE_COLUMN_DELTA;
        return {
          'grid-template-columns': `40px 380px 88px 140px repeat(${GENERAL_ESTIMATE_COLUMN_WIDTH}, 128px) repeat(${countOfDynamicCells}, 128px)`,
        };
      },
    },
    methods: {
      get,
      getSerialIndex({ index, row, company = false }) {
        let counter = 0;
        for (let localIndex in this.breakdownRows) {
          if (+localIndex === +row.tender_offer?.id) {
            break;
          }
          counter += row.breakdown_rows.length + 1;
          if (company) {
            counter -= 1;
          }
        }
        return counter + index + 1;
      },
      openedColumnsBefore(index) {
        const localIndex = this.selectedVersion[index].versionPriorityIndex;
        return this.openedColumns.filter((elem) => elem < localIndex).length;
      },
      openedColumnsAfter(index) {
        const localIndex = this.selectedVersion[index].versionPriorityIndex;
        return this.openedColumns.filter((elem) => elem > localIndex).length;
      },
      toggleCompany(index) {
        const companyIndex = this.closedCompanies.indexOf(index);
        if (companyIndex > -1) {
          this.closedCompanies.splice(companyIndex, 1);
        } else {
          this.closedCompanies.push(index);
        }
      },
      isOpened(index) {
        return this.openedColumns.includes(this.selectedVersion[index].versionPriorityIndex);
      },
      cellGroupsAfter(index) {
        const INDEX_DELTA = 1;
        return (
          Object.keys(this.selectedVersion).length -
          this.selectedVersion[index].versionPriorityIndex -
          INDEX_DELTA
        );
      },
    },
  };
</script>
